
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Switch from '@mui/material/Switch'
import _Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import _TabList from '@mui/lab/TabList'
import _TabPanel from '@mui/lab/TabPanel'

import { useMatomo } from '@jonkoops/matomo-tracker-react'

import React, { Fragment as F, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import Select from 'react-select'
import { Link, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import styled from '@emotion/styled'

import PropTypes from 'prop-types'


import {
  appRouter,
  C,
  defaultBanksQueryTmpl,
  defaultSearchRangeValue,
  logg, loggt,
  useApiRouter,
} from "$shared"

import {
  AppCtx,
} from '$src/App'
import {
  defaultSavedQuery,
  QueriesCtx,
} from '$src/components/queries'
import {
  SchedulesCtx,
} from '$src/components/schedules'

import {
  BanksCtx,
  BanksSearch,
  CriterionModal,
  operator,
} from '$src/components/banks'

library.add(
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
);

const Tab = styled(_Tab)`
  border: 1px solid gray;
  border-bottom: 0;
  border-radius: 10px 10px 0 0;
  background: var(--fff-secondary-bg-color);
  color: var(--fff-secondary-emphasis-color);
  margin-right: 0.5em;
`;
const TabList = styled(_TabList)`
  // border: 1px solid red;

  .TabListC {
    // border: 1px solid red;

    display: flex;
    flex-wrap: wrap;
  }
`;
const TabPanel = styled(_TabPanel)`
  border: 1px solid #333;
  background: var(--fff-bg-alpha1) ;
`;



/*
 * BanksSearchModal
**/
const BanksSearchModal = (props) => {
  // logg(props, 'BanksSearchModal')

  /* ctx */

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()
  const { trackPageView, trackEvent } = useMatomo()

  const {
    actionName, setActionName,
    charterAuthoritiesList,
    charterTypesList,
    loading,    setLoading,
    msasList,
    statesList,
    tradingTypesList,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in BanksSearchModal')

  const {
    bank,          setBank,
    banksSearchModalOpen, setBanksSearchModalOpen,
    criterionModalOpen, setCriterionModalOpen,
    query,         setQuery,
    results,       setResults, clearResults,
    resultsTitle,  setResultsTitle,
    selectedBanks, setSelectedBanks,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in BanksSearchModal')


  const {
    savedQuery,     setSavedQuery,
    queryModalOpen, setQueryModalOpen,
                    setSelectedQueries,
    refreshQueriesList,
  } = useContext(QueriesCtx)
  // logg(useContext(QueriesCtx), 'QueriesCtx in BanksSearchModal')

  const {
    defaultOneResultTitle,
    oneResultTitle, setOneResultTitle,
  } = useContext(SchedulesCtx)

  /* state */

  const formTabs = [
    { label: 'Demographics', clauses: [
      { label: 'Bank Name',    operator: C.op.match_i,             key: 'tbl_Bank.Bank_Name' },
      { label: 'City',         operator: C.op.match_i,             key: 'tbl_Bank.Bank_City' },
      { label: 'State',        operator: C.op.multiselect_select2, key: 'tbl_Bank.Bank_State',
          options: statesList },
      { label: 'FDIC Cert #',  operator: C.op.match_i,             key: 'tbl_Bank.Bank_Cert' },
      { label: 'RSSD ID #',    operator: C.op.match_i,             key: 'tbl_Bank.Bank_RSSD' },
      { label: 'Top Holding Company #', operator: C.op.text_field, key: 'tbl_Bank.Bank_THC_Number' },
      { label: 'Stock Symbol', operator: C.op.text_field,          key: 'tbl_Bank.Bank_Ticker' },
      { label: 'County',       operator: C.op.text_field,          key: 'tbl_Bank.Bank_County' },
      { label: 'MSA',          operator: C.op.multiselect_select2, key: 'tbl_Bank.Bank_MSA_ID',
          options: msasList },
    ], },
    { label: 'Qualify', clauses: [
      { label: 'Top 100 Banks',
        key: 'tbl_Bank.Bank_Top_Filer_Flag', operator: C.op.toggle,
        options: [ false, 'true' ],
      },
      { label: 'Include Closed Banks',
        key: 'tbl_Bank.Bank_Open_Flag',
        operator: C.op.toggle,
        options: [ '1', false ], // false/null means, the clause disappears
      },

      { label: 'Charter Type',
        key: 'tbl_Bank.Bank_Charter_Type_ID',
        operator: C.op.multiselect_select2,
        options: charterTypesList,
      },
      { label: 'Charter Authority',
        key: 'tbl_Bank.Bank_Authority_Charter_ID',
        operator: C.op.multiselect_select2,
        options: charterAuthoritiesList,
      },
      { label: 'Trading Type',
        key: 'tbl_Bank.Bank_Trading_Status',
        operator: C.op.multiselect_select2,
        options: tradingTypesList,
      },
      { className: 'total-assets',
        label: "Total Assets (000's)",
        operator: C.op.between,
        value: [ null, null ],
        key: 'View_Bank_Total_Assets.Total_Assets'
      },
    ]},
    { label: 'Search Range', clauses: [
      { className: 'search-range-criterion',
        label: "Search Criteria 1",
        operator: C.op.search_range,
        value: defaultSearchRangeValue,
        key: 'search-range.1',
      },
      { className: 'search-range-criterion',
        label: "Search Criteria 2",
        operator: C.op.search_range,
        value: {
          ubpr_code: null,
          period: null,
          op_1: null,
          val_1: null,
          op_2: null,
          val_2: null,
        },
        key: 'search-range.2',
      },
      { className: 'search-range-criterion',
        label: "Search Criteria 3",
        operator: C.op.search_range,
        value: {
          ubpr_code: null,
          period: null,
          op_1: null,
          val_1: null,
          op_2: null,
          val_2: null,
        },
        key: 'search-range.3',
      },
      { className: 'search-range-criterion',
        label: "Search Criteria 4",
        operator: C.op.search_range,
        value: {
          ubpr_code: null,
          period: null,
          op_1: null,
          val_1: null,
          op_2: null,
          val_2: null,
        },
        key: 'search-range.4',
      },
      { className: 'search-range-criterion',
        label: "Search Criteria 5",
        operator: C.op.search_range,
        value: defaultSearchRangeValue,
        key: 'search-range.5',
      },
    ], },
  ]

  const [ activeTab, setActiveTab ] = useState( formTabs[0].label)
  const [ criteriaOpts, setCriteriaOpts ] = useState([])

  /* effects */

  useEffect(() => {
    fetch(apiRouter.ubprCodesPath()).then(r => r.json()).then((rows) => {
      // logg(rows, 'BanksSearch All Ubpr Codes')
      setCriteriaOpts( rows )
    })
  }, [])

  useEffect(() => {
    trackPageView()
    trackEvent({ category: 'BanksSearchModal', action: 'show' })
  }, [ banksSearchModalOpen ])

  /* methods */

  const handleClear = () => {
    logg(null, 'handleClear')
    setQuery(JSON.parse(JSON.stringify(defaultBanksQueryTmpl)))
  }


  const handleRun = () => {
    setSelectedBanks({})
    setSelectedQueries({})
    setOneResultTitle(null)
    setLoading(true)
    const body = { query, jwt_token: localStorage.getItem('jwt_token') }
    fetch(apiRouter.queryRunPath(), { method: 'POST',
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(body),
    }).then(r => r.json()).then((rows) => {
      logg(rows, 'handleRun outcome')
      if (rows.length) {
        setResultsTitle(<F>
          <span onClick={() => setOneResultTitle(null) } >
            <u><Link to='/banks/results' >Search Results ({rows.length})</Link></u>
          </span>
          {/* { appRouter.banksResultsRoute === actionName && <Link to="/"><div className='clear-results-btn'
              onClick={clearResults}>&nbsp;&times;&nbsp;</div></Link> } */}
        </F>)

      } else {
        toast('No institutions meet this search criteria')
        setResultsTitle('No institutions meet this search criteria')
      }
      setResults(rows)
      setBanksSearchModalOpen(false)
      handleClear()
      navigate('/banks/results')
    }).catch((err) => {
      logg(err, 'Cannot handleRun')
      toast('Something went wrong. Please try again later. Code: 004')
      setResults([])
    }).finally(() => {
      setLoading(false)
      setQuery(JSON.parse(JSON.stringify(defaultBanksQueryTmpl)))
      setSavedQuery(defaultSavedQuery)
    })

  }

  const handleSave = () => {
    logg(actionName, 'handleSave')
    if (actionName === appRouter.banksResultsRoute || // "/banks/results"
        actionName === C.queries_actions.create) {
      // open modal to save the query
      setActionName(C.queries_actions.create)
      setSavedQuery({ ...savedQuery, query, })
      setQueryModalOpen(true)

    } else if (actionName === C.queries_actions.modify) { // update the query
      setLoading(true)
      apiRouter.updateQuery({
        id: savedQuery.id,
        query: { ...savedQuery, query, },
      }).then((inns) => {
        toast('Updated the query')
      }).catch((err) => {
        logg(err, 'err')
        toast('Code: 950 Could not update the query, please contact support with this error.')
      }).finally(() => {
        setLoading(false)
        setQuery(JSON.parse(JSON.stringify(defaultBanksQueryTmpl)))
        refreshQueriesList()

        setBanksSearchModalOpen(false)
        navigate('/')
        setResults([])

        setSavedQuery({})
        setSelectedQueries({})
        setSelectedResource({})

      })

    // } else if (actionName === C.queries_actions.create) {
    //   setLoading(true)
    //   fetch(apiRouter.queriesPath(), {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ ...savedQuery, query, }),
    //   }).then(r => r.json()).then(inns => {
    //     // logg(inns, 'created a query')
    //     toast('Created the query')
    //   }).catch((err) => {
    //     logg(err, 'err')
    //     toast('Code: t85 Could not create the query, please contact support with this error.')
    //   }).finally(() => {
    //     setLoading(false)
    //     setQuery(JSON.parse(JSON.stringify(defaultBanksQueryTmpl)))
    //     refreshQueriesList()

    //     setBanksSearchModalOpen(false)
    //     navigate('/')
    //     setResults([])
    //   })

    } else {
      logg("94t - this should never happen")
      toast("Code: 94t We're sorry, something went wrong. Please try again later.")
    }
  }

  const setClause = (k, v) => {
    // logg([k, v], 'setClause')

    const clauses = { ...query.clauses }
    clauses[k] = v
    setQuery({ ...query, clauses })
  }

  return <F>
    <CriterionModal />

    <Modal
      ariaHideApp={false}
      className="BanksSearchModal BaseModal"
      isOpen={banksSearchModalOpen}
      onRequestClose={ () => {
        setBanksSearchModalOpen(false)

        setSavedQuery({})
        setSelectedQueries({})
        setSelectedResource({})
      } }
      overlayClassName="ModalOverlay"
    >
      <div className='header'>
        <h5>Banks Quick Search</h5>
        <div className='close' onClick={() => {
          setBanksSearchModalOpen(false)

          setSavedQuery({})
          setSelectedQueries({})
          setSelectedResource({})
        } } >&times;</div>
      </div>
      <div className='padded'>
        <div className='BanksSearch' >
          <form data-testid="formId" onSubmit={(ev) => {
            ev.preventDefault()
            handleRun()
          } } >
            { C.queries_actions.modify === actionName && <div className='mb-2 text-center' >
              <label>Query Name&nbsp;</label>
              <input type='text' value={savedQuery.name} onChange={(ev) => setSavedQuery({ ...savedQuery, name: ev.target.value }) } />
            </div> }
            <div className={`a-tab tab-query`}>

              <TabContext value={activeTab} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={(_, val) => setActiveTab(val)} >
                    { formTabs.map((clause, idx) =>
                      <Tab key={clause.label} label={clause.label} value={clause.label} />
                    ) }
                  </TabList>
                </Box>
                { formTabs.map((formTab, idx) => <TabPanel key={formTab.label} value={formTab.label} >
                  { formTab.clauses.map((clause, idx) =>
                    <div key={clause.label} className={`d-flex align-items-start Criterion ${clause.className||''}`} style={{ marginBottom: '1em' }} >
                      <label >{ clause.label }</label>
                      { operator({
                        clause, setClause,
                        // DEBUG: clause.className || clause.label === 'Bank Name',
                        setCriterionModalOpen,
                        query, setQuery,
                      }) }
                    </div>
                  ) }
                </TabPanel> )}
              </TabContext>
              { C.queries_actions.modify === actionName && <div className='field-checkbox mt-2'>
                <input type='checkbox' checked={savedQuery.is_merge} onChange={(ev) => setSavedQuery({ ...savedQuery, is_merge: ev.target.checked }) } />
                <label>Merge</label>
              </div> }
              <div className="actions mt-2 p-0">
                <div className='left'>
                  <input type="reset" className='Btn'             onClick={handleClear}        value='Clear' ></input>
                </div>
                <div className='right'>
                  <input type='button' className='Btn btn-primary' onClick={handleSave}        value='Save'></input>
                  &nbsp; &nbsp;&nbsp;
                  <input className='Btn btn-primary' type='submit' value='Run' ></input>
                </div>
              </div>

            </div>
          </form>
        </div>{/* .BanksSearch */}
      </div>
    </Modal>

  </F>
}
export default BanksSearchModal
export {
  Tab, TabList, TabPanel,
}
